import { SafeUrl } from '@angular/platform-browser';

export class FileInfoDisplayResultDto {
    fileId: number;
    fileName: string;
    downloadUrl: string; // 	Url to download the file

    // Transient/Calculated fields
    uploadFile: File;
    uploadFileBase64: string;
    fileData: Blob | SafeUrl | string;
}
